
import React from "react";
import { FileX } from "lucide-react";
import Error from "./Error";

const NotFound = () => {
  return (
    <Error 
      title="Page Not Found"
      description="The page you are looking for might have been removed or is temporarily unavailable."
      errorCode="404"
      icon={<FileX className="h-20 w-20" />}
      actionText="Return to Home"
      actionLink="/"
    />
  );
};

export default NotFound;
